import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'
import { steps } from './onboardingSteps.js'

export function useOnboarding () {
  function startTour (pageName, ...args) {
    const pageSteps = steps[pageName.toLowerCase()]
    if (!pageSteps) return

    const resolvedSteps = typeof pageSteps === 'function'
      ? pageSteps(...args)
      : pageSteps

    const driverObj = driver({
      popoverClass: 'my-custom-popover',
      showProgress: true,
      nextBtnText: 'Далее',
      prevBtnText: 'Назад',
      doneBtnText: 'Готово',
      steps: resolvedSteps
    })
    driverObj.drive()
  }

  return { startTour }
}
